import Axios from "axios";

export enum QuickSearchResultType {
    SYSTEM_ACTION = "SYSTEM_ACTION",
    ORGANIZATION = "ORGANIZATION",
    SBOM_PROJECT = "SBOM_PROJECT",
    SBOM_PROJECT_GROUP = "SBOM_PROJECT_GROUP",
    SBOM_PROJECT_VERSION = "SBOM_PROJECT_VERSION",
    VIEW = "VIEW",
    VUL_SOURCE = "VUL_SOURCE",
    INTEREST = "INTEREST",
    USER = "USER"
}

export class QuickSearchResult {
    constructor(
        public type: QuickSearchResultType,
        public id: string,
        public title: string,
        public subtitle: string | undefined,
        public url: string) {}

    public static fromPOJO(data: any) {
        return new QuickSearchResult(
            data.type,
            data.id,
            data.title,
            data.subtitle,
            data.url
        );
    }
}

class QuickSearchService {

    readonly basePath = "/quick-search";

    public search(query: string): Promise<QuickSearchResult[]> {
        const params = new URLSearchParams();

        params.set("q", query);

        return Axios.get(`${this.basePath}?${params.toString()}`)
            .then(value => value.data.map((item: object) => QuickSearchResult.fromPOJO(item)));
    }
}

export default QuickSearchService;
